export const DotIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="2" stroke="#1D252D" strokeOpacity="0.1" strokeWidth="1.5" />
    </svg>
  );
};
